<template>
    <div>
        <table>
            <tr v-if="
            (style_selected2_name === 'プレーンシェード' || style_selected2_name === 'シャープシェード') &&
            item_data && item_data['ドレープ/レース'] === 'ドレープ' && group2 === 'ローマンシェード シングル' && mecha_selected !== 'ループレス式'
            ">
                <td>裏地</td>
                <td>
                    <b-form-select v-model="ura_selected"
                                   :options="$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['裏地'].option"></b-form-select>
                </td>
            </tr>
            <tr v-if="
            (style_selected2_name === 'プレーンシェード' || style_selected2_name === 'シャープシェード') &&
            item_data && item_data['ドレープ/レース'] === 'ドレープ' && group2 === 'ローマンシェード シングル' && mecha_selected === 'ループレス式'
            ">
                <td>裏地</td>
                <td style="display: flex;">
                    <div style=""><b-form-select style="width:auto;" disabled v-model="ura_selected"
                                   :options="$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['裏地'].option"></b-form-select></div>
                    <div style="margin: 0 0 0 10px; font-size:0.8rem;">※ループレス式の裏地ありは<br>別途価格表をご覧ください</div>
                </td>
            </tr>
            <tr>
                <td>操作メカ</td>
                <td>
                    <b-form-select style="width:auto;" v-model="mecha_selected"
                                   :options="$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['メカを選ぶ'].option"></b-form-select>
                </td>
            </tr>
            <tr v-if="style_selected2_name === 'プレーンシェードトリム'">
                <td>トリム品番を選ぶ</td>
                <td>
                    <b-form-select v-model="trim_selected"
                                   :options="$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option"></b-form-select>
                </td>
            </tr>
            <tr v-if="style_selected2_name === 'プレーンシェードボトムフリンジ付き'">
                <td>フリンジ品番を選ぶ</td>
                <td>
                    <b-form-select v-model="fringe_selected"
                                   :options="$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option"></b-form-select>
                </td>
            </tr>
            <tr v-if="style_selected2_name === 'プレーン小窓'">
                <td>台数</td>
                <td>
                    <b-form-select v-model="number_selected"
                                   :options="options"></b-form-select>
                </td>
            </tr>
            <tr v-if="group2==='ローマンシェード ツイン'">
                <td style="width: 90px;">リターン</td>
                <td>
                    <b-form-select style="display:inline-block;" v-model="return_selected"
                                   :options="$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['リターン'].option"></b-form-select>
                    <span style="font-size: 0.7rem; margin-left: 0.5rem;">※リターン付きの場合はリターンを含むサイズを入力してください。</span>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "rollscreen",
        data() {
            return {
            }
        },
        created : function(){
            const style_selected2_name = this.$store.state.step2_data.style_selected2_name
            if(this.mecha_selected === ''){
                this.mecha_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['メカを選ぶ'].option[0].value
            }
            if(
                this.ura_selected === '' && (style_selected2_name === 'プレーンシェード' || style_selected2_name === 'シャープシェード') &&
                this.$store.state.xlsx_data.item_data && this.$store.state.step1_data.item_number &&
                this.$store.state.xlsx_data.item_data['SH'+this.$store.state.step1_data.item_number] &&
                this.$store.state.xlsx_data.item_data['SH'+this.$store.state.step1_data.item_number]['ドレープ/レース'] === 'ドレープ'
            )
            {
                this.ura_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['裏地'].option[0].value
            }
            if( this.return_selected === '' &&
                this.$store.state.step2_data.style_selected2_id &&
                this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2==='ローマンシェード ツイン'
            ){
                this.return_selected = 'リターンなし'
            }
            if( this.trim_selected === '' && style_selected2_name === 'プレーンシェードトリム'){
                this.trim_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option[0].value
            }
            if( this.fringe_selected === '' && style_selected2_name === 'プレーンシェードボトムフリンジ付き'){
                this.fringe_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option[0].value
            }
            if( this.number_selected === '' && style_selected2_name === 'プレーン小窓'){
                this.number_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['台数'].option[0].value
            }
        },
        watch: {
            style_selected2_id: function(value){
                const style_selected2_name = this.$store.state.step2_data.style_selected2_name
                if(this.mecha_selected === ''){
                    this.mecha_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['メカを選ぶ'].option[0].value
                }
                if(
                    this.ura_selected === '' && (style_selected2_name === 'プレーンシェード' || style_selected2_name === 'シャープシェード') &&
                    this.$store.state.xlsx_data.item_data && this.$store.state.step1_data.item_number &&
                    this.$store.state.xlsx_data.item_data['SH'+this.$store.state.step1_data.item_number] &&
                    this.$store.state.xlsx_data.item_data['SH'+this.$store.state.step1_data.item_number]['ドレープ/レース'] === 'ドレープ'
                ){
                    this.ura_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['裏地'].option[0].value
                }
                if( this.return_selected === '' && this.$store.state.step2_data.style_selected2_id &&
                    this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2==='ローマンシェード ツイン'){
                    this.return_selected = 'リターンなし'
                }
                if( this.trim_selected === '' && style_selected2_name === 'プレーンシェードトリム'){
                    this.trim_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option[0].value
                }
                if( this.fringe_selected === '' && style_selected2_name === 'プレーンシェードボトムフリンジ付き'){
                    this.fringe_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['フリンジ品番・トリム品番を選ぶ'].option[0].value
                }
                if( this.number_selected === '' && style_selected2_name === 'プレーン小窓'){
                    this.number_selected = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][style_selected2_name]['台数'].option[0].value
                }
            },
        },
        computed: {
            options:{
                get:function(){
                    if(parseInt(this.$store.state.step3_data.width_size) >= 43){
                        //小窓巾対策
                        let options = []    //参照渡し対策
                        let option_data = this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][this.$store.state.step2_data.style_selected2_name]['台数'].option
                        for(let index in option_data){
                            if(!option_data[index].value.match(/3台/)) {
                                options.push(option_data[index])
                            }
                        }
                        if(this.number_selected ==='3台'){
                            this.number_selected = '1台'
                        }

                        return options
                    }
                    else{
                        return this.$store.state.xlsx_select_data.select_data['ロールスクリーン＆ローマンシェード'][this.$store.state.step2_data.style_selected2_name]['台数'].option
                    }
                }
            },
            mecha_selected: {
                get: function () {
                    return this.$store.state.step3_data.mecha
                },
                set: function (value) {
                    const style_selected2_name = this.$store.state.step2_data.style_selected2_name
                    if(value==='ループレス式'){
                        this.$store.commit('updateOptionSelected', {name:'ura', value:'裏地なし'})
                    }
                    this.$store.commit('updateOptionSelected', {name:'mecha', value:value})
                }
            },
            ura_selected: {
                get: function () {
                    return this.$store.state.step3_data.ura
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'ura', value:value})
                }
            },
            trim_selected: {
                get: function () {
                    return this.$store.state.step3_data.trim
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'trim', value:value})
                }
            },
            fringe_selected: {
                get: function () {
                    return this.$store.state.step3_data.fringe
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'fringe', value:value})
                }
            },
            return_selected: {
                get: function () {
                    return this.$store.state.step3_data.return_type
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'return_type', value:value})
                }
            },
            number_selected: {
                get: function () {
                    return this.$store.state.step3_data.window_number
                },
                set: function (value) {
                    this.$store.commit('updateOptionSelected', {name:'window_number', value:value})
                }
            },
            width_size: {
                get: function () {
                    return this.$store.state.step3_data.width_size
                },
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else{
                        return ''
                    }

                },
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
            style_selected2_id: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_id
                },
            },
            item_data: {
                get: function () {
                    if(
                        this.$store.state.step1_data.item_number &&
                        this.$store.state.xlsx_data.item_data &&
                        typeof(this.$store.state.xlsx_data.item_data['SH'+this.$store.state.step1_data.item_number]) !=='undefined'
                    ){
                        return this.$store.state.xlsx_data.item_data['SH'+this.$store.state.step1_data.item_number]
                    }
                    return ''
                },
            },
        },
    }
</script>

<style scoped>

</style>